export default __webpack_public_path__ + "static/media/btn-alle-lieder.bd753558.webp";